export const AVERAGE_ENGAGEMENT_RATE = 'Avg. Engagement Rate';
export const INSTAGRAM_STATISTICS = 'instagram-statistics';
